import React, { Fragment } from 'react';
import { ListGroupItem } from 'reactstrap';

const LI = (props) => {
  const { children = '', val = '', attrLI = {}, ...rest } = props;

  return (
    <Fragment>
      <ListGroupItem {...attrLI} {...rest}>
        {val ? <div dangerouslySetInnerHTML={{ __html: val }} /> : ''}
        {children}
      </ListGroupItem>
    </Fragment>
  );
};

export default LI;
